import { enUS, frFR, nlBE } from '@clerk/localizations';
import { DEFAULT_LANGUAGE, type Language, toSupported } from '@/i18n/language';

type TranslateFn = (key: string) => string;
type ClerkLocalization = typeof enUS;

/** Belgian Dutch rather than nl-NL — Circus Daily's players are in Belgium. */
const PACKS: Record<Language, ClerkLocalization> = { en: enUS, fr: frFR, nl: nlBE };

/**
 * Clerk UI locale pack for the app language, with brand overrides for
 * sign-in / sign-up titles that match our i18n catalog.
 */
export function getClerkLocalization(language: string, t: TranslateFn): ClerkLocalization {
  const base = PACKS[toSupported(language) ?? DEFAULT_LANGUAGE];

  return {
    ...base,
    signIn: {
      ...base.signIn,
      start: {
        ...base.signIn?.start,
        title: t('auth.clerk.signIn'),
      },
    },
    signUp: {
      ...base.signUp,
      start: {
        ...base.signUp?.start,
        title: t('auth.clerk.createAccount'),
        actionText: t('auth.clerk.alreadyHaveAccount'),
        actionLink: t('auth.clerk.signIn'),
      },
    },
  };
}
